<template>
  <div class="workflow">
    <div class="breadcrumb">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>创造</el-breadcrumb-item>
        <el-breadcrumb-item>工作流</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    
    <div class="workflow-header">
      <div class="header-left">
        <div class="header-title">工作流</div>
        <div class="header-desc">组合大模型和各类工具，可视化编排智能应用流程</div>
      </div>
      <div class="header-actions">
        <el-button type="primary" icon="el-icon-plus" @click="createWorkflow">创建工作流</el-button>
      </div>
    </div>
    
    <div class="workflow-content">
      <div class="filter-area">
        <el-tabs v-model="activeTab" class="main-tabs">
          <el-tab-pane label="全部" name="all"></el-tab-pane>
          <el-tab-pane label="收藏" name="starred"></el-tab-pane>
          <el-tab-pane label="最近使用" name="recent"></el-tab-pane>
        </el-tabs>
        
        <div class="search-area">
          <el-input
            placeholder="搜索工作流"
            prefix-icon="el-icon-search"
            v-model="searchText"
            clearable
          ></el-input>
        </div>
      </div>
      
      <div class="workflow-list">
        <el-empty v-if="filteredWorkflows.length === 0" description="暂无工作流"></el-empty>
        
        <el-row :gutter="20" v-else>
          <el-col :span="6" v-for="workflow in filteredWorkflows" :key="workflow.id">
            <div class="workflow-card" @click="openWorkflow(workflow)">
              <div class="workflow-preview">
                <img :src="workflow.preview" :alt="workflow.name" v-if="workflow.preview">
                <div class="workflow-no-preview" v-else>
                  <i class="el-icon-set-up"></i>
                </div>
                <div class="workflow-actions">
                  <i class="el-icon-star-off" @click.stop="toggleStar(workflow)" :class="{ 'starred': workflow.starred }"></i>
                  <el-dropdown trigger="click" @click.stop>
                    <i class="el-icon-more"></i>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="editWorkflow(workflow)">重命名</el-dropdown-item>
                      <el-dropdown-item @click.native="duplicateWorkflow(workflow)">复制</el-dropdown-item>
                      <el-dropdown-item @click.native="exportWorkflow(workflow)">导出</el-dropdown-item>
                      <el-dropdown-item @click.native="deleteWorkflow(workflow)" class="danger-item">
                        删除
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <div class="workflow-info">
                <div class="workflow-name">{{ workflow.name }}</div>
                <div class="workflow-meta">
                  <span class="workflow-time">{{ workflow.updatedAt }}</span>
                  <span class="workflow-author">{{ workflow.author }}</span>
                </div>
              </div>
              <div class="workflow-footer">
                <div class="workflow-status" :class="workflow.status">
                  <el-tag size="mini" :type="workflow.status === 'published' ? 'success' : 'info'">
                    {{ workflow.status === 'published' ? '已发布' : '草稿' }}
                  </el-tag>
                </div>
                <div class="workflow-usage">
                  <i class="el-icon-view"></i> {{ workflow.views }}
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    
    <el-dialog
      title="创建新工作流"
      :visible.sync="createDialogVisible"
      width="500px"
    >
      <el-form :model="newWorkflow" label-position="top">
        <el-form-item label="工作流名称">
          <el-input v-model="newWorkflow.name" placeholder="请输入工作流名称"></el-input>
        </el-form-item>
        <el-form-item label="工作流描述">
          <el-input type="textarea" v-model="newWorkflow.description" placeholder="请输入工作流描述" rows="3"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmCreate" :disabled="!newWorkflow.name">确定</el-button>
      </span>
    </el-dialog>
    
    <el-dialog
      title="编辑工作流"
      :visible.sync="editDialogVisible"
      width="500px"
    >
      <el-form :model="editingWorkflow" label-position="top" v-if="editingWorkflow">
        <el-form-item label="工作流名称">
          <el-input v-model="editingWorkflow.name" placeholder="请输入工作流名称"></el-input>
        </el-form-item>
        <el-form-item label="工作流描述">
          <el-input type="textarea" v-model="editingWorkflow.description" placeholder="请输入工作流描述" rows="3"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmEdit" :disabled="!editingWorkflow.name">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Workflow',
  data() {
    return {
      activeTab: 'all',
      searchText: '',
      createDialogVisible: false,
      editDialogVisible: false,
      newWorkflow: {
        name: '',
        description: ''
      },
      editingWorkflow: null,
      workflows: [
        {
          id: 1,
          name: '客户咨询处理流程',
          description: '处理客户咨询的智能工作流',
          preview: require('@/assets/workflow-preview1.png'),
          author: '张三',
          updatedAt: '2024-05-15',
          starred: true,
          status: 'published',
          views: 1245
        },
        {
          id: 2,
          name: '数据分析报告生成',
          description: '自动化数据分析报告生成流程',
          preview: '',
          author: '李四',
          updatedAt: '2024-05-14',
          starred: false,
          status: 'draft',
          views: 856
        },
        {
          id: 3,
          name: '产品反馈收集与处理',
          description: '收集和处理用户产品反馈',
          preview: require('@/assets/workflow-preview2.png'),
          author: '王五',
          updatedAt: '2024-05-12',
          starred: true,
          status: 'published',
          views: 2178
        },
        {
          id: 4,
          name: '智能文档摘要',
          description: '自动从文档中提取关键信息并生成摘要',
          preview: '',
          author: '赵六',
          updatedAt: '2024-05-10',
          starred: false,
          status: 'draft',
          views: 564
        },
        {
          id: 5,
          name: '团队日报自动生成',
          description: '根据团队成员输入自动生成日报',
          preview: require('@/assets/workflow-preview3.png'),
          author: '张三',
          updatedAt: '2024-05-08',
          starred: false,
          status: 'published',
          views: 1523
        },
        {
          id: 6,
          name: '客户支持自动回复',
          description: '根据常见问题自动生成回复',
          preview: '',
          author: '李四',
          updatedAt: '2024-05-05',
          starred: false,
          status: 'published',
          views: 987
        }
      ]
    };
  },
  computed: {
    filteredWorkflows() {
      let result = this.workflows;
      
      // 筛选标签页
      if (this.activeTab === 'starred') {
        result = result.filter(w => w.starred);
      } else if (this.activeTab === 'recent') {
        // 这里假设按更新时间排序就是最近使用的
        result = [...result].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)).slice(0, 3);
      }
      
      // 搜索文本
      if (this.searchText) {
        const searchLower = this.searchText.toLowerCase();
        result = result.filter(w => 
          w.name.toLowerCase().includes(searchLower) || 
          w.description.toLowerCase().includes(searchLower)
        );
      }
      
      return result;
    }
  },
  created() {
    // 在实际环境中，这里通常会从API获取工作流列表
  },
  methods: {
    createWorkflow() {
      this.createDialogVisible = true;
      this.newWorkflow = {
        name: '',
        description: ''
      };
    },
    confirmCreate() {
      // 在实际应用中，这里应该请求API创建新工作流
      const newId = Math.max(...this.workflows.map(w => w.id)) + 1;
      const workflow = {
        id: newId,
        name: this.newWorkflow.name,
        description: this.newWorkflow.description,
        preview: '',
        author: 'Current User',
        updatedAt: new Date().toISOString().split('T')[0],
        starred: false,
        status: 'draft',
        views: 0
      };
      
      this.workflows.unshift(workflow);
      this.createDialogVisible = false;
      this.$message.success('创建成功');
      
      // 跳转到工作流编辑页面
      this.openWorkflow(workflow);
    },
    openWorkflow(workflow) {
      this.$message.info(`打开工作流: ${workflow.name}`);
      // 在实际应用中，这里应该跳转到工作流编辑器页面
    },
    toggleStar(workflow) {
      workflow.starred = !workflow.starred;
      this.$message.success(workflow.starred ? '已添加收藏' : '已取消收藏');
    },
    editWorkflow(workflow) {
      this.editingWorkflow = { ...workflow };
      this.editDialogVisible = true;
    },
    confirmEdit() {
      const index = this.workflows.findIndex(w => w.id === this.editingWorkflow.id);
      if (index !== -1) {
        const updated = { ...this.workflows[index], ...this.editingWorkflow };
        this.$set(this.workflows, index, updated);
        this.$message.success('修改成功');
      }
      this.editDialogVisible = false;
    },
    duplicateWorkflow(workflow) {
      const newId = Math.max(...this.workflows.map(w => w.id)) + 1;
      const duplicated = {
        ...workflow,
        id: newId,
        name: `${workflow.name} (副本)`,
        status: 'draft',
        views: 0,
        updatedAt: new Date().toISOString().split('T')[0]
      };
      
      this.workflows.unshift(duplicated);
      this.$message.success('复制成功');
    },
    exportWorkflow(workflow) {
      this.$message.info(`导出工作流: ${workflow.name}`);
      // 在实际应用中，这里应该触发工作流导出功能
    },
    deleteWorkflow(workflow) {
      this.$confirm(`确认删除工作流 "${workflow.name}"?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.workflows = this.workflows.filter(w => w.id !== workflow.id);
        this.$message.success('删除成功');
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    }
  }
};
</script>

<style scoped>
.workflow {
  padding-bottom: 50px;
}

.breadcrumb {
  margin-bottom: 20px;
}

.workflow-header {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}

.header-desc {
  color: #606266;
  font-size: 14px;
}

.workflow-content {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.filter-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.search-area {
  width: 240px;
}

.workflow-list {
  margin-top: 20px;
}

.workflow-card {
  height: 100%;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  transition: all 0.3s;
  margin-bottom: 20px;
  cursor: pointer;
}

.workflow-card:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.workflow-preview {
  height: 160px;
  position: relative;
  overflow: hidden;
}

.workflow-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.workflow-no-preview {
  width: 100%;
  height: 100%;
  background-color: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: #909399;
}

.workflow-actions {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 10px;
}

.workflow-actions i {
  font-size: 18px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
}

.workflow-actions i:hover {
  background-color: rgba(0, 0, 0, 0.7);
}

.workflow-actions i.starred {
  color: #FFCC00;
}

.workflow-info {
  padding: 12px;
}

.workflow-name {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.workflow-meta {
  font-size: 12px;
  color: #909399;
  display: flex;
  justify-content: space-between;
}

.workflow-footer {
  padding: 12px;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.workflow-usage {
  font-size: 12px;
  color: #909399;
}

.danger-item {
  color: #F56C6C;
}
</style> 